/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object } from "yup";
import { toast } from "react-toastify";
import { useGetUserBrQuery } from "../../Store/Services/UserService";
import * as Yup from "yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useSelector } from "react-redux";

import styles from "./AddUser.module.css";
import {
  useUpdateUserMutation,
  useGetUserByIdQuery,
} from "../../Store/Services/UserService";
import { useEffect } from "react";

const schema = object({
  userFirstName: Yup.string(),
  userLastName: Yup.string(),
  userName: Yup.string(),
  userEmail: Yup.string().email(""),
  userTelephone: Yup.string(),
  userMobile: Yup.string(),
  userPsw: Yup.string()
    .min(
      8,
      "password should be with 1 uppercase 1 lowercase 1 number 1 special character and it should be more than 8 characters  "
    )

    .max(
      12,
      "password should be with 1 uppercase 1 lowercase 1 number 1 special character and it should be more than 8 characters  "
    )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  userConfPsw: Yup.string().oneOf(
    [Yup.ref("userPsw"), null],
    "Passwords must match"
  ),
}).required();

const EditUser = ({ handleClose }) => {
  const [userBr, setUserBr] = useState([]);
  const [deletedBr, setDeletedBr] = useState([])
  const [newUserBr, setNewUserBr] = useState([])
  const [showPassword, setShowPassword] = useState(false);

  const { data, isSuccess: brSuccess, isLoading: brLoading } = useGetUserBrQuery();
  const userId = useSelector((state) => state.user.selectedUser);
  const [userUpdateResponse] = useUpdateUserMutation();

  const {
    data: userDetailsResponse,
    isSuccess,
    isLoading,
  } = useGetUserByIdQuery(userId);
  //   console.log(userDetailsResponse, "userDetailsResponse--->");

  let userDetails = {};

  if (isSuccess) {
    userDetails = userDetailsResponse;
  }

  console.log(userDetails);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  let brList;
  if (brSuccess) {
    brList = data?.map((br) => ({ brId: br.brId, brName: br.brName }));
    console.log('br', brList);
  }

  const setBrName = () => {
    setUserBr(userDetails?.userBR?.map((br) => ({ brId: br.brId, brName: br.brName, userXrefBrId: br.userXrefBrId })));
  };

  useEffect(() => {
    setBrName();
  }, []);

  useEffect(() => {
    reset({
        userFirstName: userDetails?.userFirstName,
        userLastName: userDetails?.userLastName,
        userName: userDetails?.userName,
        userEmail: userDetails?.userEmail,
        userTelephone: userDetails?.userTelephone,
        userMobile: userDetails?.userMobile,
    })
  }, [userDetails])

  const onSubmit = async (data) => {
    const dataSet = {
      ...data,
      userId: userId,
      userBr: newUserBr.map(br => br.brId),
      deletedBr: deletedBr.map(br => br.userXrefBrId),
      userProPic: "www",
    };
    console.log('delbr', deletedBr);
    console.log("data set", dataSet);

    try {
      const userUpdate = await userUpdateResponse(dataSet).unwrap();
      console.log('user update', userUpdate);
      toast.success("User successfully Created!", { position: "bottom-right" });
    } catch (err) {
      console.error("Failed to edit user details: ", err);
      toast.error(err.data?.message, { position: "bottom-right" });
    }
    handleClose();
  };

  const handleClickShowPassword = () => {
    setShowPassword((currentShowState) => !currentShowState);
  };

  return (
    <div>
      <div className={styles.headingContainer}>
        <Typography fontWeight={600} variant={"h6"}>
          Edit User
        </Typography>
        <IconButton className={styles.closeButton} onClick={handleClose}>
          <Close />
        </IconButton>
      </div>

      {isSuccess && !isLoading && brSuccess && !brLoading && <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.imageDev}>
          <Avatar
            // className={styles.avatar}
            style={{
              width: "110px",
              height: "110px",
              border: "solid 1px #9e1618",
            }}
            src={`${process.env.REACT_APP_IMAGE_URL}INVENTORY%2Favatar.png`}
          />
        </div>

        {/* Add Item form Here... */}
        <div className={styles.filed}>
          <Typography className={styles.formLabale}>First Name</Typography>
          <TextField
            {...register("userFirstName")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Last Name</Typography>
          <TextField
            {...register("userLastName")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Username</Typography>
          <TextField
            {...register("userName")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Email</Typography>
          <TextField
            {...register("userEmail")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>
            Telephone Number
          </Typography>
          <TextField
            {...register("userTelephone")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Mobile Number</Typography>
          <TextField
            {...register("userMobile")}
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Password</Typography>

          <TextField
            {...register("userPsw", { minLength: 8 })}
            size="small"
            fullWidth
            className={styles.formTextFilde}
            placeholder="Enter Password"
            type={showPassword ? "text" : "password"}
            error={!!errors.userPsw}
            helperText={errors.userPsw?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        
        <div className={styles.filed}>
          <Typography className={styles.formLabale}>
            Conform Password
          </Typography>

          <TextField
            {...register("userConfPsw")}
            size="small"
            fullWidth
            className={styles.formText}
            placeholder="Confrm Password:"
            type={showPassword ? "text" : "password"}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={styles.formItem}>
          <label className={styles.formLabel}>User Br:</label>
          {brSuccess && (
            <Autocomplete
              className={styles.formInput}
              onChange={(_, newBr,reason, detail) => {
                if (reason === 'removeOption') {
                  setDeletedBr(prev => [...prev, detail.option])
                } else if (reason === 'selectOption') {
                  setNewUserBr(prev => [...prev, detail.option])
                }
                setUserBr(newBr.map((br) => ({ brId: br.brId, brName: br.brName, userXrefBrId: br.userXrefBrId })));
              }}
              size="small"
              multiple
              filterSelectedOptions
              isOptionEqualToValue={(option, value) =>
                option.brName === value.brName
              }
              value={userBr}
              options={brList}
              getOptionLabel={(option) => option.brName}
              renderInput={(params) => (
                <TextField {...params} />
              )}
            />
          )}
        </div>
        <div className={styles.buttonRap}>
          <Button
            className={styles.submitButton}
            type="submit"
            variant="contained"
            fullWidth
            // disabled={isLoading}
          >
            Edit User
          </Button>
        </div>
      </form>}
    </div>
  );
};

export default EditUser;
